// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_Q-yW- clearfix","box_r":"index_box_r_XBcJp","d_box":"index_d_box_nx3IW"};